module.exports = __webpack_public_path__ + "img/organization-settings.cc7221e2.png";